import { render, staticRenderFns } from "./ComplexEarthLogo.vue?vue&type=template&id=b45f8276&scoped=true&"
import script from "./ComplexEarthLogo.vue?vue&type=script&lang=js&"
export * from "./ComplexEarthLogo.vue?vue&type=script&lang=js&"
import style0 from "./ComplexEarthLogo.vue?vue&type=style&index=0&id=b45f8276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45f8276",
  null
  
)

export default component.exports